import { FC } from 'lib/component-utils'

const Markdown: FC<{ content: string }, 'div'> = ({ content, ...rest }) => {
  return <div {...rest} dangerouslySetInnerHTML={{ __html: content }}></div>
}

export default Markdown
